var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":"代码块","effect":"dark","placement":"top"}},[_c('section',{staticClass:"upword-wrap",on:{"click":_vm.onClick}},[_c('svg-icon',{staticClass:"upword",attrs:{"icon-class":"codeblock"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }